<template>
    <rkm-area
        background-color="secondary"
        closed
        header-prefix-icon="user-injured"
        title="Atendimento"
        type="box"
    >

        <rkm-row>
            <rkm-col cols="4">
                <Item
                    :get-value="() => item.dataAtendimento"
                    label="Data de atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.horarioAtendimento"
                    label="Hora de atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.codUnAtendimento"
                    label="Unidade de atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.cnesUnAtendimento"
                    label="CNES da unidade de atendimento"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.profissional"
                    label="Profissional"
                />
            </rkm-col>

            <rkm-col cols="8">
                <Item
                    :get-value="() => item.hipoteseDiagnostica"
                    label="Hipótese diagnostica"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.cid10"
                    label="CID 10"
                />
            </rkm-col>

            <rkm-col cols="12">
                <Item
                    :get-value="() => item.descricaoProcedimento"
                    label="Descrição procedimento"
                />
            </rkm-col>

            <rkm-col cols="12">
                <Item
                    :get-value="() => item.descricaoExameClinico"
                    label="Exame clínico"
                />
            </rkm-col>

            <rkm-col cols="12">
                <Item
                    :get-value="() => item.condutaMedica"
                    label="Conduta médica"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>